export default {"src":"/_next/static/media/info_green.416898fa.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};